import { render, staticRenderFns } from "./PaymentDetailsTypeConcessionaria.vue?vue&type=template&id=90c3abf0"
import script from "./PaymentDetailsTypeConcessionaria.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsTypeConcessionaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports